import React from 'react'
import { DocCard, ExternalLinks } from '../../components'
import {
  ContrastLogo,
  ContrastProtect,
  ContrastScan,
  ContrastServerless,
  ContrastAccessControl,
  ContrastAudit,
  ContrastAgentDashboard,
  ContrastAssess,
  ContrastPlatform,
  ContrastScim
} from '../../svgs'
import './home.scss'
import { NavLink } from 'react-router-dom'
import { useSpecManifest } from '../../hooks'

const Header = () => (
  <header className="home__header">
    <nav className="home__header-nav">
      <div className="home__header-nav--left">
        <NavLink to="/">
          <ContrastLogo />
        </NavLink>
      </div>
      <div className="home__header-nav--right">
        <ExternalLinks toggleSm />
      </div>
    </nav>
    <div className="home__header-banner">
      <h1>Contrast API Documentation</h1>
    </div>
  </header>
)

const Footer = () => (
  <footer className="home__footer home__media-width">
    © {new Date().getFullYear()} Contrast Security
  </footer>
)

export const Home = () => {
  const { status, getLatestLink } = useSpecManifest()

  return (
    <div className="home" data-testid="home-page">
      <Header />

      <div className="home__body">
        <div className="home__body-cards home__media-width">
          <DocCard
            title="Assess, Protect & Core"
            version="v1, v2, v3"
            icon={<ContrastProtect />}
            link="https://api-ng.contrastsecurity.com/"
          />

          <DocCard
            title="Scan"
            icon={<ContrastScan />}
            link={getLatestLink('scan')}
            status={status}
          />

          <DocCard
            title="Serverless"
            icon={<ContrastServerless />}
            link={getLatestLink('serverless')}
            status={status}
          />

          <DocCard
            title="Assess (beta)"
            version="v4"
            icon={<ContrastAssess />}
            link={getLatestLink('assess')}
            status={status}
          />

          <DocCard
            title="Agent Dashboard"
            version="v4"
            icon={<ContrastAgentDashboard />}
            link={getLatestLink('agent-dashboard')}
            status={status}
          />
        </div>
        <br />
        <br />
        <div className="home__body-smallcards home__media-width">
          <DocCard
            title="Access Control"
            version="v4"
            icon={<ContrastAccessControl />}
            link={getLatestLink('access-control')}
            status={status}
          />

          <DocCard
            title="Audit"
            version="v4"
            icon={<ContrastAudit />}
            link={getLatestLink('audit')}
            status={status}
          />

          <DocCard
            title="Platform"
            version="v1"
            icon={<ContrastPlatform />}
            link={getLatestLink('platform')}
            status={status}
          />
          <DocCard
            title="SCIM"
            version="v2"
            icon={<ContrastScim />}
            link={getLatestLink('scim')}
            status={status}
          />
        </div>
      </div>

      <Footer />
    </div>
  )
}
